<template>
  <svg
    width="24" height="24"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="20" cy="20" r="20" fill="#00305D" id="infoIconSolid"/>
    <path
      d="M17.3625 10.3125C17.3625 9.44922 17.8195 8.6875 18.5813 8.23047C19.2922 7.77344 20.257 7.77344 21.0188 8.23047C21.7297 8.6875 22.2375 9.44922 22.2375 10.3125C22.2375 11.2266 21.7297 11.9883 21.0188 12.4453C20.257 12.9023 19.2922 12.9023 18.5813 12.4453C17.8195 11.9883 17.3625 11.2266 17.3625 10.3125ZM14.925 17.625C14.925 16.7617 15.6359 16 16.55 16H19.8C20.6633 16 21.425 16.7617 21.425 17.625V29H23.05C23.9133 29 24.675 29.7617 24.675 30.625C24.675 31.5391 23.9133 32.25 23.05 32.25H16.55C15.6359 32.25 14.925 31.5391 14.925 30.625C14.925 29.7617 15.6359 29 16.55 29H18.175V19.25H16.55C15.6359 19.25 14.925 18.5391 14.925 17.625Z"
      fill="white"
    />
  </svg>
</template>
<script>
export default {
  name: "mapIcon",
};
</script>

<style lang="scss">
#infoIconSolid {
  fill: var(--result_map_info_svg_color, #00305D);
}
</style>




